import React from 'react';

/**
 * Inline SVG that defines reusable filters.
 * `removeWhiteBg` — turns near-white pixels transparent so a photograph
 * with a white studio background (like the Prestige logo photo) blends
 * seamlessly onto any surface (marble, gradient, etc.).
 */
const SvgFilters = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
  >
    <defs>
      <filter id="removeWhiteBg" colorInterpolationFilters="sRGB">
        {/* Alpha = 3 - R - G - B (clamped 0..1). White becomes 0, gold stays 1. */}
        <feColorMatrix
          type="matrix"
          values="1 0 0 0 0
                  0 1 0 0 0
                  0 0 1 0 0
                  -1 -1 -1 3 0"
        />
        {/* Sharpen the alpha channel to remove milky fringes and keep edges crisp */}
        <feComponentTransfer>
          <feFuncA type="linear" slope="2.2" intercept="-0.35" />
        </feComponentTransfer>
        {/* Small blur then re-sharpen for anti-aliased alpha edges */}
        <feGaussianBlur stdDeviation="0.25" />
        <feComponentTransfer>
          <feFuncA type="linear" slope="1.6" intercept="-0.05" />
        </feComponentTransfer>
      </filter>

      <filter id="removeBlackBg" colorInterpolationFilters="sRGB">
        {/* Alpha = R + G + B (clamped 0..1). Black becomes 0, gold stays 1. */}
        <feColorMatrix
          type="matrix"
          values="1 0 0 0 0
                  0 1 0 0 0
                  0 0 1 0 0
                  1 1 1 0 0"
        />
        {/* Sharpen the alpha channel — crisper edges, no dark halo */}
        <feComponentTransfer>
          <feFuncA type="linear" slope="2.4" intercept="-0.35" />
        </feComponentTransfer>
        {/* Anti-alias smoothing */}
        <feGaussianBlur stdDeviation="0.25" />
        <feComponentTransfer>
          <feFuncA type="linear" slope="1.6" intercept="-0.05" />
        </feComponentTransfer>
      </filter>
    </defs>
  </svg>
);

export default SvgFilters;
